<template>
  <div>
    <b-modal
      v-b-modal.modal-center
      no-close-on-backdrop
      hide-header
      id="proessingTerminal"
      ref="modal"
    >
      <div class="text-center pt-4">
        <svg
          width="90"
          height="90"
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#59A5D8"
        >
          <g fill="none" fill-rule="evenodd" stroke-width="2">
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="0s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="0s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="22" cy="22" r="1">
              <animate
                attributeName="r"
                begin="-0.9s"
                dur="1.8s"
                values="1; 20"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.165, 0.84, 0.44, 1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-opacity"
                begin="-0.9s"
                dur="1.8s"
                values="1; 0"
                calcMode="spline"
                keyTimes="0; 1"
                keySplines="0.3, 0.61, 0.355, 1"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
        <br />
        <br />

        <h2>Waiting On Payment</h2>
        To cancel this payment, press cancel on the Poynt device.
        <br />
      </div>

      <template #modal-header>
        <div class="w-100"></div>
      </template>
      <template #modal-footer><div></div> </template>
    </b-modal>

    <ask
      ref="partialAsk"
      title="Partial Amount Approved"
      :message="partialMessage"
      @ok="processPartialAmount"
    ></ask>

    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(submitToTerminal)">
        <div>
          <b-row>
            <b-col style="padding-top: 4px;">
              <b-form-group
                id="input-group-3"
                label="Terminal"
                label-for="terminal"
                class="form-control-label"
              >
                <b-form-select
                  id="terminal"
                  v-model="form.terminal"
                  :options="terminals"
                ></b-form-select>
              </b-form-group>
              <b-form-checkbox
                id="checkbox-1"
                v-model="defaultTerminal"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                class="text-muted"
                >Use this as my default terminal
              </b-form-checkbox>
            </b-col>
            <b-col>
              <base-input-currency
                class="mb-3"
                name="paymentAmount"
                ref="paymentAmount"
                rules="required|money|greaterThanZero"
                mode="passive"
                label="Payment Amount"
                v-model="form.paymentAmount"
                :setNewValue="setNewPaymentValue"
                prependChar="$"
                :disabled="paymentAmountDisabled"
              />
            </b-col>
          </b-row>

          <b-button
            class="btn-block mt-3"
            variant="primary"
            ref="submit"
            type="submit"
            >Send
            <span v-if="form.paymentAmount">{{
              form.paymentAmount | currency
            }}</span>
            to Terminal</b-button
          >
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import MSelect from "@/components/extended/Select";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";

import PaymentTypes from "./PaymentTypes.vue";

export default {
  name: "pay-by-terminal",
  props: {
    customer: null,
    afterTransactionUri: null,
    addAppts: null,
    giftCard: null,
    amount: null,
  },
  components: {
    MSelect,

    PaymentTypes,
  },

  watch: {
    amount: {
      handler: function(newVal, oldVal) {
        this.setNewPaymentValue = this.amount / 100;
        this.form.paymentAmount = this.amount / 100;
      },
      immediate: true,
    },
    customer(customer) {},
  },
  async created() {
    if (self.customer && self.customer.balance) {
      if (self.customer.balance > 0)
        this.form.paymentAmount = self.customer.balance;
      else this.form.paymentAmount = "";
    }
  },
  async mounted() {
    var self = this;

    self.$refs.paymentAmount.$el.querySelector("input").focus();
    self.$refs.paymentAmount.$el.querySelector("input").select();

    if (!this.$localStorageService.getItem("terminals")) {
      console.log("Getting Terminals From Api...");
      var result = await self.$client.get("/api/terminal/terminals");

      self.terminals = [];

      self.terminals = self.terminals.concat(
        result.data.value.terminals.map((m) => {
          return { value: m.key, text: m.description };
        })
      );

      this.$localStorageService.setItem(
        "terminals",
        JSON.stringify(self.terminals)
      );
    } else {
      console.log("Getting Terminals from Local Storage...");
      self.terminals = JSON.parse(
        this.$localStorageService.getItem("terminals")
      );
    }

    // if we have 1 terminal default it and set it
    if (self.terminals.length == 1) {
      self.form.terminal = self.terminals[0].value;
    } else {
      var defaultTerminal = self.$cookies.get("defaultTerminal");

      if (defaultTerminal) self.form.terminal = defaultTerminal;
      else self.form.terminal = self.terminals[0].value;
    }
  },
  methods: {
    onPaymentTypeChange(paymentType) {
      this.paymentAmountDisabled = paymentType == "PROCEDUREPAYMENT";
      this.paymentType = paymentType;
    },
    proceduresChanged(procedures) {
      this.procedures = procedures;
    },
    cancelProcessingTerminal() {
      this.cancelTokenSource.cancel();
      this.$refs.partialModal.hide();
    },
    closePartialModal() {
      this.$refs.partialModal.hide();
      location.href = this.afterTransactionUri;
    },
    processPartialAmount() {
      this.form.paymentAmount =
        ((this.form.paymentAmount * 100).toFixed(0) - this.processedAmount) /
        100;

      this.$refs.submit.click();
    },

    handleSingleResult(r) {
      var self = this;

      if (r.status == "TIMEOUT") {
        self.$emitter.emit("error", "A previous transaction timed out.");
        this.$bvModal.hide("proessingTerminal");
      } else if (r.status == "CANCELED") {
        self.$emitter.emit("error", "The transaction was canceled");
      } else if (r.status == "DECLINED") {
        self.$emitter.emit("noSuccess-confirm", {
          title: "Transaction Declined",
          message: r.statusMessage,
        });
      } else if (r.status == "APPROVED" && r.fundingSource == "CARD") {
        if ((self.form.paymentAmount * 100).toFixed(0) != r.amount) {
          this.processedAmount = r.amount;

          let p1 = `A partial payment was approved for ${self.$options.filters.currency(
            this.processedAmount / 100
          )}`;

          let partialMessage = `${p1}.  Would you like to process another transaction for the remaining balance of ${self.$options.filters.currency(
            ((self.form.paymentAmount * 100).toFixed(0) -
              this.processedAmount) /
              100
          )}?`;

          swal
            .fire({
              title: "Partial Payment Processed",
              text: partialMessage,
              showCancelButton: true,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              cancelButtonClass: "btn btn-warning",
              icon: "success",
              confirmButtonText: `Yes`,
              cancelButtonText: `No`,
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.processPartialAmount();
              } else {
                location.href = this.afterTransactionUri;
              }
            });
        } else {
          self.$emitter.emit("success-confirm", {
            title: "Transaction Approved",
            message: "Transaction ID: " + r.transactionId.split("-")[0],
            navigate: this.afterTransactionUri,
          });
          this.$emit("transactionComplete", r);
        }
      } else if (r.status == "APPROVED" && r.fundingSource == "CASH") {
        self.$emitter.emit("success-confirm", {
          title: "Cash Transaction Completed",
          message: "Transaction ID: " + r.transactionId.split("-")[0],
          navigate: this.afterTransactionUri,
        });
      } else if (r.status == "APPROVED" && r.fundingSource == "CHECK") {
        self.$emitter.emit("success-confirm", {
          title: "Check Transaction Completed",
          message: "Transaction ID: " + r.transactionId.split("-")[0],
          navigate: this.afterTransactionUri,
        });
      } else {
        alert("Unknown status returned " + r.status);
      }
    },
    handleMultipleResults() {
      let html = `<table class="table table-sm mt-3"><tr><td align="left" class="pl-0"><b>Transaction ID</b></td><td align="right" class="pr-0"><b>Amount</b></td></tr>`;

      this.paymentResults.forEach((e) => {
        let c = this.$options.filters.currency(e.amount / 100);
        html += `<tbody><tr><td align="left" class="pl-0">${
          e.transactionId.split("-")[0]
        }</td><td align="right" class="pr-0">${c}</td></tbody>`;
      });

      let total = this.paymentResults.reduce((acc, a) => {
        return (acc.amount += a.amount);
      });

      total = this.$options.filters.currency(total / 100);

      html += `<tr><td colspan="2" align="right" class="pr-0"><b>Total: ${total}</b></td></tr></table>`;

      swal
        .fire({
          title: "Payments Processed",
          html: html,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success",
          icon: "success",
          confirmButtonText: `Ok`,
        })
        .then(() => {
          location.href = this.afterTransactionUri;
        });

      this.$emit("transactionComplete", r);
    },
    async submitToTerminal() {
      var self = this;

      if (this.form.paymentAmount == 0) {
        this.$emitter.emit("error", "Payment Amount cannot be 0");
        return;
      }

      self.cancelTokenSource = axios.CancelToken.source();
      self.cancelToken = self.cancelTokenSource.token;

      this.$bvModal.show("proessingTerminal");

      if (self.defaultTerminal) {
        self.$cookies.set("defaultTerminal", self.form.terminal, "y3");
      }

      try {
        let p = {
          deviceKey: self.form.terminal,
          email: self.customer.email,
          amount: (self.form.paymentAmount * 100).toFixed(0),
          noProgress: true,
          customerId: self.customer.id,
          addAppts: this.addAppts,
          giftCard: this.giftCard,
          paymentType: this.paymentType,
        };

        var result = await self.$client.post(
          "/api/terminal/sendToTerminal",
          p,
          {
            cancelToken: self.cancelToken,
          }
        );

        this.$bvModal.hide("proessingTerminal");

        if (result.data.value.sendToTerminalDtoItems.length == 1) {
          this.handleSingleResult(result.data.value.sendToTerminalDtoItems[0]);
        } else if (result.data.value.sendToTerminalDtoItems.length > 1) {
          this.paymentResults = result.data.value.sendToTerminalDtoItems;
          this.handleMultipleResults();
        }
      } catch (ex) {
        // Cancel
        this.$bvModal.hide("proessingTerminal");
        throw ex;
      }
    },
  },
  data: function() {
    return {
      defaultTerminal: false,
      paymentAmountDisabled: false,
      terminals: [],
      cancelTokenSource: null,
      cancelToken: null,
      processedAmount: null,
      partialMessage: null,
      paymentResults: [],
      procedures: [],
      setNewPaymentValue: null,
      paymentType: "PREPAYMENT",
      form: {
        terminal: null,
        paymentAmount: null,
      },
    };
  },
};
</script>
